import { Injectable } from '@angular/core';
import { BaseHttpService } from '../shared-services/base-http.service';
import { Observable } from 'rxjs';
import { ClientRegistration } from '../../models/client-registration';
import { ApiUrlsConstant } from '../../../app-constant';
import { ResponseVm } from '../../models/response-vm';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseHttpService {
  apiUrls: any = ApiUrlsConstant;


  firstTimeLogin(data: any): Observable<ResponseVm> {
    return this.post<ResponseVm>(this.apiUrls.firstTimelogin, data);
  }

  changePassword(data: any): Observable<ResponseVm> {
    return this.post<ResponseVm>(this.apiUrls.changePassword, data);
  }

  login(data: any): Observable<ResponseVm> {
    return this.post<ResponseVm>(this.apiUrls.login, data);
  }

  checkOtp(data: any): Observable<ResponseVm> {
    return this.post<ResponseVm>(this.apiUrls.checkOtpNo, data);
  }
  resendOtp(data: any): Observable<ResponseVm> {
    return this.post<ResponseVm>(this.apiUrls.resendOtp, data);
  }

  forgotPassword(data: any): Observable<ResponseVm> {
    return this.post<ResponseVm>(this.apiUrls.forgotPassword, data);
  }
  verifyPassword(userId: string, otp: string): Observable<ResponseVm> {
    let params = new HttpParams()
    if (userId) params = params.set('userId', userId);
    if (otp) params = params.set('otp', otp.toString());
    return this.get<any>(this.apiUrls.forgotPassword, params);
  }
  updatePassword(data: any): Observable<ResponseVm> {
    return this.put<ResponseVm>(this.apiUrls.forgotPassword, data);
  }
}
